/** Validate delimiters without interpreting HTML, CSS or placeholder values. */
export const hasValidPlaceholderSyntax = (source: string): boolean => {
    const token = /\{\{|\}\}/g
    let opening: number | null = null
    for (const match of source.matchAll(token)) {
        if (match[0] === '{{') {
            if (opening !== null || source[match.index - 1] === '{') return false
            opening = match.index + 2
        } else {
            if (opening === null || source[match.index + 2] === '}') return false
            const expression = source.slice(opening, match.index).trim()
            // Preserve the conditional syntax supported by existing offer templates.
            if (!/^[a-zA-Z_]\w*(?:\s+if:\w+\s+text="[^"]+")?$/.test(expression)) return false
            opening = null
        }
    }
    return opening === null
}

export interface HtmlTemplateBlock {
    id: string
    name: string
    html: string
    collection?: string
}

export const readHtmlBlocks = (key: string): HtmlTemplateBlock[] => {
    const raw: unknown = JSON.parse(localStorage.getItem(key) ?? '[]')
    if (!Array.isArray(raw) || !raw.every((block) =>
        block && typeof block.id === 'string' && typeof block.name === 'string' && typeof block.html === 'string' && (block.collection === undefined || typeof block.collection === 'string')
    )) throw new Error('Invalid local block library')
    return raw
}
